import React from 'react';

import { IconCheckMark } from '@trqk/components';

interface TopPlanFeaturesProps {
    list: string[];
    title: string;
}

/**
 * Renders a title and list of top plan features
 * @param props - see {@link TopPlanFeaturesProps}
 */
export const TopPlanFeatures = ({
    list,
    title,
}: TopPlanFeaturesProps): JSX.Element => (
    <>
        <div className="text-sm font-bold mt-8 mb-3">{title}</div>
        <div className="space-y-2">
            {list.map(
                (feature: string): JSX.Element => (
                    <div
                        key={feature}
                        className="text-sm font-normal grid"
                        style={{ gridTemplateColumns: '26px auto' }}
                    >
                        <IconCheckMark fillColor="secondary-500" width={20} />
                        {feature}
                    </div>
                ),
            )}
        </div>
    </>
);
